import React, { memo, ReactElement } from 'react';
import { Button } from 'reactApp/ui/Button/Button';

import styles from './SelectAlbumPopupEmpty.css';

export const SelectAlbumPopupEmpty = memo(function SelectAlbumPopupEmpty({ onCreateAlbum }: { onCreateAlbum(): void }): ReactElement {

    return (
        <div className={styles.empty}>
            <div className={styles.folder} />
            <span className={styles.title}>У вас пока нет альбомов</span>
            <span className={styles.text}>Создайте свой первый альбом и добавляйте в него фото</span>

            <Button 
                theme="vk" 
                primary 
                className={styles.button}
                onClick={onCreateAlbum}
            >
                Создать альбом
            </Button>
        </div>
    );
});
